import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allEquiposAction, setActivoEquiposAction } from './EquiposAction';
import FormEquipos from './components/FormEquipos';
import ListadoEquipos from './components/ListadoEquipos';

const EquiposView = () => {
  const dispatch = Redux.useDispatch();

  const equiposStore = Redux.useSelector((state) => state.equipos);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoEquiposAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoEquiposAction(dispatch, null);
            await allEquiposAction(dispatch, equiposStore.params);
          }}
          disabled={equiposStore.all.length === 0 || equiposStore.loadingAll}
          white
          refreshIcon
          text={equiposStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoEquipos setOpenModalForm={(val) => setOpenModalForm(val)} />
      </Grid>
      <ModalComponent
        id="modalFormEquipos"
        title={`${
          equiposStore.activo
            ? `Editar ${equiposStore.activo.nombre}`
            : 'Nuevo equipo'
        }`}
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormEquipos setOpenModalForm={(val) => setOpenModalForm(val)} />
      </ModalComponent>
    </Grid>
  );
};

export default EquiposView;
